export const notZeroValidator = (value) => {
  if (!value) {
    return true
  }
  return (Number.parseInt(value) !== 0)
}
